'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { useEffect } from 'react';

import { getLegacyEnvVariable } from '@/app/components/LegacyEnvVariables/util';
import { COUNTRY_COOKIE } from '@/app/consts/cookies';
import { LOGGER_NAME } from '@/logger/consts';
import { getCookie } from '@/utils/cookie';
import isBrowser from '@/utils/isBrowser';

let initialized = false;

const DatadogLogsInit = () => {
  useEffect(() => {
    if (!isBrowser() || initialized) return;

    const clientToken = getLegacyEnvVariable('NEXT_PUBLIC_DD_CLIENT_TOKEN');
    const ouraEnv = getLegacyEnvVariable('NEXT_PUBLIC_OURA_ENV');

    if (!clientToken) {
      throw new Error(
        'No Datadog client token set, please add the NEXT_PUBLIC_DD_CLIENT_TOKEN environment variable.',
      );
    }

    datadogLogs.init({
      clientToken,
      env: ouraEnv,
      forwardErrorsToLogs: false,
      service: LOGGER_NAME,
      sessionSampleRate: 100,
      site: 'datadoghq.com',
    });

    datadogLogs.addLoggerGlobalContext('env', ouraEnv);
    datadogLogs.addLoggerGlobalContext('service', LOGGER_NAME);

    const region = getCookie(COUNTRY_COOKIE);
    if (region) {
      datadogLogs.addLoggerGlobalContext('region', region);
    }

    initialized = true;
  }, []);

  return null;
};

export default DatadogLogsInit;
